import { styles } from './template.scss';
import { styles as commonStyles } from '../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../assets/widget-shared.scss';
import { FontSizes, FontWeights } from '../../types/common/types';

export const templateAlerts = document.createElement('template');

templateAlerts.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${widgetSharedStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

    <gz-push-body-layout>
        <div slot="push-body-sidenav">
             <gz-grid-smart-views class="hidden"></gz-grid-smart-views>
             <div class="loader">
                <gz-loader rows="4" class="smartview-loader"></gz-loader>
                <gz-loader rows="4" class="smartview-loader"></gz-loader>
             </div>
        </div>
        <div slot="push-body-sidenav-title">
            <gz-title id="smartViewsTitle" fontweight="600" fontsize="11" ></gz-title>
        </div>
        <div class="alerts push-body"  slot="push-body-content">
            <div class="push-body--menu"></div>
             <div class="push-body--content">
                <div class="wrapper">
                    <div class="alerts-header">
                        <div class="alerts-header--top">
                            <gz-title class="title" fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'>Threats Xplorer</gz-title>
                        </div>
                    </div>
                    <div class="alerts-content">
                        <div class="alerts-grid">
                            <gz-grid-view enableCSVExport noEscapeSpaceInTitle>
                            </gz-grid-view>
                        </div>
                        <gz-side-menu id="detailsPanel" menuwidth="400" closeOnClickOutside resizable="left" isResponsive="true"></gz-side-menu>
                    </div>
                    <gz-image-repo state="error" class="loading-error">
                        <gz-text fontSize="14" fontWeight="400" class="loading-error--message" />
                    </gz-image-repo>
                </div>
             </div>
          ${/* TBD: error screens */ ''}
        </div>
    </gz-push-body-layout>

`;
